import { CoordinateRange } from 'src/app/shared/constants/coordinates.constants';

// An empty field is valid (coordinates are optional); only an entered number outside the range is an error.
export function isOutOfRange(value: unknown, range: CoordinateRange): boolean {
    return typeof value === 'number' && (value < range.min || value > range.max);
}
